<template>
  <report-viewer mainCategory="0"></report-viewer>
</template>
<script>
import ReportViewer from "@/components/ReportViewer/ReportViewer";
import apis from "@/apis";
import { detectTenant, filterCasteDropdown } from "@/tenantConfig";
export default {
  components: { ReportViewer },
  mounted() {
    let dist = this.$store.getters.getdistricts;
    if (dist.length == 0) {
      let Promise = apis.ReadMasters();
      Promise.then((response) => {
        if (response.status == 200) {
          this.$store.dispatch("setApplicationStatus", response.body.Table);
          this.$store.dispatch("setDistricts", response.body.Table1);
          this.$store.dispatch("setLoanType", response.body.Table2);
          this.$store.dispatch("setBanks", response.body.Table3);
          this.$store.dispatch("setClaimStatus", response.body.Table4);
          this.$store.dispatch("setAmountRange", response.body.Table5);
          this.$store.dispatch("setAgeRange", response.body.Table6);
        }
        let today = new Date();
        let curr_year = today.getFullYear();
        let financial_year_list = [];
        if (today.getMonth() + 1 <= 3) {
          curr_year -= 1;
        }

        while (curr_year >= 2020) {
          let financial_year = curr_year + "-" + (curr_year + 1);
          financial_year_list.push({ fy: financial_year });
          curr_year--;
        }
        this.$store.dispatch("setFYList", financial_year_list);
      }).catch(() => {
      });

      let promiseA = apis.getCaste();

      promiseA.then((response) => {
        if (response.status == 200) {
          this.$store.dispatch("setCasteList", filterCasteDropdown(response.body, detectTenant()));
        }
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AdminReports/Report.vue